import './Finances.scss'

import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import financesService from '../../services/Finances'
import {
  calendarDateInputToBackendFormat,
  dateNowToCalendarInput
} from '../../services/utils'
import FinancesFilterDateRange from './FinancesFilterDateRange'
import FinancesFilterOperator from './FinancesFilterOperator'
import FinancesPane from './FinancesPane'

const ReportCancelledWebPayments = () => {
  const intl = useIntl()

  const [startTime, setStartTime] = useState(dateNowToCalendarInput())
  const [endTime, setEndTime] = useState(dateNowToCalendarInput())
  const [mandator, setMandator] = useState([])

  const onChangeMandatorValue = (value) => {
    setMandator(value)
  }

  return (
    <FinancesPane
      text={intl.formatMessage({
        id: 'finances.tab.reportCancelledWebPayments.header'
      })}
      extraContent={
        <FinancesFilterOperator onChangeMandatorValue={onChangeMandatorValue} />
      }
      buttonCallback={() =>
        financesService.downloadCancelledWebPaymentsReport({
          startDate: calendarDateInputToBackendFormat(startTime),
          endDate: calendarDateInputToBackendFormat(endTime),
          settlementRecipientRef: mandator
        })
      }
    >
      <FinancesFilterDateRange
        startTime={startTime}
        setStartTime={setStartTime}
        endTime={endTime}
        setEndTime={setEndTime}
      />
    </FinancesPane>
  )
}

export default ReportCancelledWebPayments
